<kendo-textbox [readonly]="true" [placeholder]="placeholder" [value]="valueAsString" #anchor class="qpoint-multi-view-date-range-picker-input-text" [class.with-arrows]="showNavigationArrows">
  <ng-template kendoTextBoxPrefixTemplate>
    <qpoint-button *ngIf="showNavigationArrows" icon="chevron-left" class="navigation-arrow"
                 (buttonClicked)="decrementValue()" variant="icon" [disabled]="isPrevDisabled()"></qpoint-button>
  </ng-template>

  <ng-template kendoTextBoxSuffixTemplate>
    <qpoint-button *ngIf="showNavigationArrows" icon="chevron-right" class="navigation-arrow"
                 (buttonClicked)="incrementValue()" variant="icon" [disabled]="isNextDisabled()"></qpoint-button>
    <div *ngIf="showClearButton && value?.start && value?.end" class="d-flex dateRangePickerClearButton" (click)="resetValue($event)">
      <span class="k-icon k-i-close k-clear-value p-0"></span>
    </div>
    <qpoint-button *ngIf="showCalendarButton" icon="calendar-days" (buttonClicked)="togglePopup()" btnClass="h-100"
      [disabled]="disabled" variant="icon" iconType="regular" class="calendar-button"></qpoint-button>
  </ng-template>
</kendo-textbox>

<kendo-popup #popup [anchor]="anchor.input" *ngIf="showPopup" class="qpoint-multi-view-date-range-picker-popup">
  <div class="d-flex align-items-end qpoint-multi-view-date-range-picker-popup-header"
       [class.justify-content-end]="mode === 'single'" [class.justify-content-between]="mode === 'range'">
    <div class="row" *ngIf="mode === 'range'">
      <div class="col">
        <label class="label" for="valueStart">
          {{translations.from | translate}}
        </label><br>
        <input id="valueStart" kendoTextBox [value]="value.start ? (value.start | qPointDateFormat:format) : ''" readonly/>
      </div>
      <div class="col" *ngIf="mode === 'range'">
        <label class="label" for="valueEnd">
          {{translations.to | translate}}
        </label><br>
        <input id="valueEnd" kendoTextBox [value]="value.end ? (value.end | qPointDateFormat:format) : ''" readonly/>
      </div>
    </div>
    <div class="button-group ml-auto" *ngIf="showModeSelection">
      <qpoint-button type="button" class="range" [variant]="mode === 'single' ? 'primary' : 'secondary'"
                     (buttonClicked)="changeSelectionMode('single')">
        {{translations.modeSingle | translate}}
      </qpoint-button>
      <qpoint-button type="button" class="date" [variant]="mode === 'single' ? 'secondary' : 'primary'"
                     (buttonClicked)="changeSelectionMode('range')">
        {{translations.modeRange | translate}}
      </qpoint-button>
    </div>
  </div>
  <div class="d-flex flex-row">
    <div class="calendar-navigation-area">
      <qpoint-icon-button icon="chevron-left" (buttonClicked)="calendarPrev()"></qpoint-icon-button>
      <qpoint-button class="today-button" variant="secondary" (buttonClicked)="calendarToday()">{{'kendoMessage.today' | translate}}</qpoint-button>
    </div>
    <kendo-multiviewcalendar kendoDateRangeSelection (selectionRangeChange)="selectionRangeChanged($event)"
                             (activeRangeEndChange)="activeRangeEndChanged($event)" [disabledDatesRangeValidation]="disabledDatesRangeValidation"
                             [selectionRange]="value" [disabled]="disabled" [showViewHeader]="showViewHeader"
                             [weekNumber]="weekNumber" [views]="views" [headerTitleTemplate]="null" [focusedDate]="today" [disabledDates]="disabledDates">
    </kendo-multiviewcalendar>
    <div class="calendar-navigation-area">
      <qpoint-icon-button icon="chevron-right" (buttonClicked)="calendarNext()"></qpoint-icon-button>
    </div>
  </div>
</kendo-popup>
